import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TimeIcon } from "./image-components/time";
import { TrackingEventTypes } from "./types/analytics";
import { ReturnToCheckoutExpiredStillAvailable } from "./card-content/expired-still-available/expired-still-available-card.component";
import { ReturnToCheckoutExpiredUnavailable } from "./card-content/expired-unavailable/expired-unavailable-card.component";
import { ReturnToCheckoutExpiringSoon } from "./card-content/expiring-soon/expiring-soon-card.component";
import { LoadingCard } from "./card-content/loading-card/loading-card.component";
import { ReturnToCheckoutOrderActive } from "./card-content/order-active/order-active-card.component";
import Modal from "./modal";
import styles from "./return-to-checkout-modal.module.css";
import { useReturnToCheckoutModalTracking } from "./return-to-checkout-modal.tracking";
import { ModalState } from "./return-to-checkout-modal.types";
import { Text } from "@cinch-labs/design-system";
import { useCallback, useEffect, useState } from "react";
import { findVehiclePath, personalDetailsPagePath, returnToCheckoutStage } from "@cinch-labs/shared-util";
export var CheckoutStage;
(function(CheckoutStage) {
    CheckoutStage["PersonalDetails"] = "PersonalDetails";
    CheckoutStage["PartExchange"] = "PartExchange";
    CheckoutStage["Finance"] = "Finance";
    CheckoutStage["DeliverySlots"] = "DeliverySlots";
    CheckoutStage["Extras"] = "Extras";
    CheckoutStage["CinchCare"] = "CinchCare";
    CheckoutStage["Payment"] = "Payment";
    CheckoutStage["SignUp"] = "SignUp";
})(CheckoutStage || (CheckoutStage = {}));
export var returnToCheckoutOrderActiveTestId = "return-to-checkout-order-active-test-id";
export var returnToCheckoutExpiringSoonTestId = "return-to-checkout-expiring-soon-test-id";
export var returnToCheckoutExpiredStillAvailableTestId = "return-to-checkout-expired-still-available-test-id";
export var returnToCheckoutExpiredUnavailableTestId = "return-to-checkout-expired-unavailable-test-id";
export var i18n = {
    orderActive: {
        title: "Continue buying this car?",
        buttonText: "Return to checkout",
        secondaryButtonText: "I don't want this car"
    },
    expiringSoon: {
        title: "Your order is timing out",
        text: "We'll reserve this car for another {bold}{timeRemaining}{/bold}",
        buttonText: "Return to checkout",
        secondaryButtonText: "I don't want this car"
    },
    expiredStillAvailable: {
        title: "Your order timed out",
        text: "But the car is still available! Want to start a new order with the same car?",
        buttonText: "Go to checkout"
    },
    expiredUnavailable: {
        title: "Car no longer available",
        text: "We’re sorry you missed it - but we have 1,000s of other cars in stock. Start a new search to find yours.",
        buttonText: "Browse all cars"
    },
    loading: "Loading...",
    adminFee: "Plus a {adminFeeValue} admin fee"
};
export var cancelOrderReason = "Return to Checkout - I don't want this car";
var hasExpired = function(expiresAt) {
    return expiresAt === undefined ? false : Date.now() > expiresAt;
};
export var noOpTracking = function(event) {
    console.log("noop::trackEvent::".concat(event.type !== TrackingEventTypes.IDENTIFY && event.eventName), event);
};
export var ReturnToCheckoutModal = function(param) {
    var activeOrder = param.activeOrder, onClose = param.onClose, lastVisitedCheckoutStage = param.lastVisitedCheckoutStage, timeRemainingInSeconds = param.timeRemainingInSeconds, withinExpiryTimeWindow = param.withinExpiryTimeWindow, _adminFeeFlag = param.adminFeeFlag, adminFeeFlag = _adminFeeFlag === void 0 ? false : _adminFeeFlag, _adminFeeValueInPence = param.adminFeeValueInPence, adminFeeValueInPence = _adminFeeValueInPence === void 0 ? 0 : _adminFeeValueInPence, cancelOrder = param.cancelOrder, isLoggedIn = param.isLoggedIn, accessToken = param.accessToken, refreshActiveOrder = param.refreshActiveOrder, checkIfVehicleIsReserved = param.checkIfVehicleIsReserved, extendOrderExpiryDate = param.extendOrderExpiryDate, trackEvent = param.trackEvent, handleShouldShowBasketIcon = param.handleShouldShowBasketIcon;
    var ref = useReturnToCheckoutModalTracking(trackEvent !== null && trackEvent !== void 0 ? trackEvent : noOpTracking), resumeCheckoutClosedModal = ref.resumeCheckoutClosedModal, resumeCheckoutReturnedToCheckout = ref.resumeCheckoutReturnedToCheckout, iDoNotWantThisCarEvent = ref.iDoNotWantThisCarEvent, returnToCheckoutModalEvent = ref.returnToCheckoutModalEvent, resumeCheckoutOpenedModal = ref.resumeCheckoutOpenedModal;
    var vehicle = activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle;
    var orderId = activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.id;
    var ref1 = useState(undefined), currentOrder = ref1[0], setCurrentOrder = ref1[1];
    var ref2 = useState(false), buttonLoading = ref2[0], setButtonLoading = ref2[1];
    var ref3 = useState(false), secondaryButtonLoading = ref3[0], setSecondaryButtonLoading = ref3[1];
    var ref4 = useState(false), vehicleIsReserved = ref4[0], setVehicleIsReserved = ref4[1];
    var ref5 = useState(false), modalLoading = ref5[0], setModalLoading = ref5[1];
    var ref6;
    var orderHasExpired = hasExpired((ref6 = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.expiresAt) !== null && ref6 !== void 0 ? ref6 : currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cancelledAt);
    useEffect(function() {
        if (activeOrder && orderHasExpired && checkIfVehicleIsReserved) {
            setModalLoading(true);
            var getReservationStatus = function() {
                var _ref = _async_to_generator(function() {
                    var reservationStatus;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    checkIfVehicleIsReserved(activeOrder.vehicle.id)
                                ];
                            case 1:
                                reservationStatus = _state.sent();
                                setVehicleIsReserved(reservationStatus.reserved);
                                setModalLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function getReservationStatus() {
                    return _ref.apply(this, arguments);
                };
            }();
            getReservationStatus();
        }
    }, [
        activeOrder,
        orderHasExpired,
        vehicle,
        checkIfVehicleIsReserved
    ]);
    var extendExpiry = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!accessToken) {
                        return [
                            2
                        ];
                    }
                    if (!orderId) return [
                        3,
                        2
                    ];
                    setButtonLoading(true);
                    return [
                        4,
                        extendOrderExpiryDate === null || extendOrderExpiryDate === void 0 ? void 0 : extendOrderExpiryDate(orderId, accessToken)
                    ];
                case 1:
                    _state.sent();
                    setButtonLoading(false);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        orderId,
        extendOrderExpiryDate,
        accessToken
    ]);
    var removeOrderForUser = function() {
        var _ref = _async_to_generator(function(token) {
            var ref, orderDetails, _tmp, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!refreshActiveOrder) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        _tmp = activeOrder;
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            cancelOrder === null || cancelOrder === void 0 ? void 0 : cancelOrder(activeOrder.id, cancelOrderReason, token)
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        orderDetails = _tmp;
                        switch((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) || ((ref = // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.data) === null || ref === void 0 ? void 0 : ref.orderStatus) === "Cancelled"){
                            case 200:
                                setCurrentOrder(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.data);
                                refreshActiveOrder();
                                onClose();
                                handleShouldShowBasketIcon();
                                break;
                            case 403:
                                handleShouldShowBasketIcon();
                                window.location.assign("/login");
                                break;
                            default:
                                refreshActiveOrder();
                                break;
                        }
                        return [
                            2,
                            setSecondaryButtonLoading(false)
                        ];
                    case 4:
                        e = _state.sent();
                        // eslint-disable-next-line unicorn/no-useless-undefined
                        setCurrentOrder(undefined);
                        refreshActiveOrder();
                        return [
                            2,
                            setSecondaryButtonLoading(false)
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function removeOrderForUser(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveOrder = function() {
        var _ref = _async_to_generator(function() {
            var isUserValid;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        iDoNotWantThisCarEvent();
                        setSecondaryButtonLoading(true);
                        isUserValid = accessToken && isLoggedIn;
                        if (!!isUserValid) return [
                            3,
                            1
                        ];
                        window.location.assign("/login");
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            removeOrderForUser(accessToken)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var onModalOpen = function(modalState) {
        resumeCheckoutOpenedModal(modalState);
    };
    var onButtonClick = function() {
        var _ref = _async_to_generator(function() {
            var ref;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        returnToCheckoutModalEvent();
                        return [
                            4,
                            extendExpiry()
                        ];
                    case 1:
                        _state.sent();
                        returnToCheckoutStage((ref = lastVisitedCheckoutStage === null || lastVisitedCheckoutStage === void 0 ? void 0 : lastVisitedCheckoutStage.stage) !== null && ref !== void 0 ? ref : "PersonalDetails", activeOrder);
                        return [
                            2
                        ];
                }
            });
        });
        return function onButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var onButtonClickExpiredOrderVehicleStillAvailable = function() {
        resumeCheckoutReturnedToCheckout(ModalState.expiredStillAvailable);
        vehicle && window.location.assign("".concat(personalDetailsPagePath).concat(vehicle.id));
    };
    var onButtonClickExpiredOrderVehicleUnavailable = function() {
        refreshActiveOrder && refreshActiveOrder();
        resumeCheckoutReturnedToCheckout(ModalState.expiredUnavailable);
        window.location.assign(findVehiclePath);
    };
    var onModalCloseExpiredOrderVehicleUnavailable = function() {
        refreshActiveOrder && refreshActiveOrder();
        resumeCheckoutClosedModal(ModalState.expiredStillAvailable);
        onClose();
    };
    var onModalClose = function(modalState) {
        resumeCheckoutClosedModal(modalState);
        onClose();
    };
    var styleCardTitle = function(title, icon) {
        if (icon) {
            return /*#__PURE__*/ _jsx(Text, {
                element: "h5",
                className: styles.cardTitle,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.titleWithIconContainer,
                    children: [
                        /*#__PURE__*/ _jsx(TimeIcon, {
                            className: styles.timeIcon,
                            "data-testid": "time-icon-modal-title"
                        }),
                        title
                    ]
                })
            });
        }
        return /*#__PURE__*/ _jsx(Text, {
            element: "h5",
            className: styles.cardTitle,
            children: title
        });
    };
    var getTitle = function(modalState) {
        switch(modalState){
            case ModalState.active:
                return styleCardTitle(i18n.orderActive.title);
            case ModalState.expiringSoon:
                return styleCardTitle(i18n.expiringSoon.title, true);
            case ModalState.expiredStillAvailable:
                return styleCardTitle(i18n.expiredStillAvailable.title, true);
            case ModalState.expiredUnavailable:
                return styleCardTitle(i18n.expiredUnavailable.title);
        }
    };
    if (modalLoading || !activeOrder) {
        return /*#__PURE__*/ _jsx(Modal, {
            onClose: onClose,
            title: "Loading",
            classNames: styles,
            closeable: true,
            children: /*#__PURE__*/ _jsx(LoadingCard, {})
        });
    }
    if (withinExpiryTimeWindow) {
        var returnToCheckoutModalState = ModalState.expiringSoon;
        return /*#__PURE__*/ _jsx(Modal, {
            testId: returnToCheckoutExpiringSoonTestId,
            onClose: function() {
                return onModalClose(returnToCheckoutModalState);
            },
            classNames: styles,
            closeable: true,
            children: /*#__PURE__*/ _jsx(ReturnToCheckoutExpiringSoon, {
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                title: getTitle(returnToCheckoutModalState),
                timeRemainingInSeconds: timeRemainingInSeconds,
                onButtonClick: function() {
                    return onButtonClick();
                },
                onSecondaryButtonClick: function() {
                    return handleRemoveOrder();
                },
                vehicle: vehicle,
                isButtonLoading: buttonLoading,
                isSecondaryButtonLoading: secondaryButtonLoading,
                i18n: i18n.expiringSoon,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent,
                onModalOpen: onModalOpen
            })
        });
    }
    if (orderHasExpired) {
        if (!vehicleIsReserved) {
            var returnToCheckoutModalState1 = ModalState.expiredStillAvailable;
            return /*#__PURE__*/ _jsx(Modal, {
                testId: returnToCheckoutExpiredStillAvailableTestId,
                onClose: function() {
                    return onModalClose(returnToCheckoutModalState1);
                },
                classNames: styles,
                closeable: true,
                children: /*#__PURE__*/ _jsx(ReturnToCheckoutExpiredStillAvailable, {
                    adminFeeFlag: adminFeeFlag,
                    adminFeeValueInPence: adminFeeValueInPence,
                    onButtonClick: onButtonClickExpiredOrderVehicleStillAvailable,
                    title: getTitle(returnToCheckoutModalState1),
                    vehicle: vehicle,
                    i18n: i18n.expiredStillAvailable,
                    isButtonLoading: buttonLoading,
                    trackEvent: trackEvent,
                    noOpTracking: noOpTracking,
                    onModalOpen: onModalOpen
                })
            });
        } else {
            var returnToCheckoutModalState2 = ModalState.expiredUnavailable;
            return /*#__PURE__*/ _jsx(Modal, {
                testId: returnToCheckoutExpiredUnavailableTestId,
                onClose: onModalCloseExpiredOrderVehicleUnavailable,
                classNames: styles,
                closeable: true,
                children: /*#__PURE__*/ _jsx(ReturnToCheckoutExpiredUnavailable, {
                    adminFeeFlag: adminFeeFlag,
                    adminFeeValueInPence: adminFeeValueInPence,
                    onButtonClick: onButtonClickExpiredOrderVehicleUnavailable,
                    title: getTitle(returnToCheckoutModalState2),
                    vehicle: vehicle,
                    i18n: i18n.expiredUnavailable,
                    isButtonLoading: buttonLoading,
                    trackEvent: trackEvent,
                    noOpTracking: noOpTracking,
                    onModalOpen: onModalOpen
                })
            });
        }
    }
    var returnToCheckoutModalState3 = ModalState.active;
    return /*#__PURE__*/ _jsx(Modal, {
        testId: returnToCheckoutOrderActiveTestId,
        onClose: function() {
            return onModalClose(returnToCheckoutModalState3);
        },
        classNames: styles,
        closeable: true,
        children: /*#__PURE__*/ _jsx(ReturnToCheckoutOrderActive, {
            adminFeeFlag: adminFeeFlag,
            adminFeeValueInPence: adminFeeValueInPence,
            onButtonClick: function() {
                return onButtonClick();
            },
            onSecondaryButtonClick: function() {
                return handleRemoveOrder();
            },
            title: getTitle(returnToCheckoutModalState3),
            vehicle: vehicle,
            i18n: i18n.orderActive,
            isButtonLoading: buttonLoading,
            isSecondaryButtonLoading: secondaryButtonLoading,
            trackEvent: trackEvent,
            noOpTracking: noOpTracking,
            onModalOpen: onModalOpen
        })
    });
};
export default ReturnToCheckoutModal;
